<div>
    <app-ativacao-section-card
        [control]="ativacaoControl"
        titulo="Tributação Regular"
        descricaoAtivo="Tributação Regular ativa. O CST e a classificação tributária abaixo serão aplicados no cálculo desta regra tributária."
        descricaoInativo="Tributação Regular inativa. Esta regra tributária não informa a tributação regular."
        emptyStateTitulo="Tributação Regular desativada"
        emptyStateDescricao="Ative a Tributação Regular acima para informar o CST e a classificação tributária regular.">
    </app-ativacao-section-card>

    @if (ativacaoControl.value) {
    <app-regra-tributaria-trib-regular-section
        [form]="regForm"
        [csts]="csts"
        [cclasstribs]="cclasstribs"
        [formulas]="formulas">
    </app-regra-tributaria-trib-regular-section>
    }
</div>
